import { render, staticRenderFns } from "./OpenReport_10_1_2.vue?vue&type=template&id=fd807b50&"
import script from "./OpenReport_10_1_2.vue?vue&type=script&lang=js&"
export * from "./OpenReport_10_1_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports